// removed by extract-text-webpack-plugin
module.exports = {"page_buy":"app__css__app-pages-SelfHelp-buyFa-__index__page_buy","step-input":"app__css__app-pages-SelfHelp-buyFa-__index__step-input","btn_icon":"app__css__app-pages-SelfHelp-buyFa-__index__btn_icon"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/SelfHelp/buyFa/index.css
// module id = 1565
// module chunks = 0